var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"table-responsive"},[_c('LotesList',{attrs:{"postura_id":_vm.postura_id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }